import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';

const SELECT_DATA = [
  { backgroundColor: '#070d59', color: 'white', txt: 'Select', disabled: true },
  { backgroundColor: '#76D773', color: 'white', txt: 'Have This', disabled: false },
  { backgroundColor: '#FFBF00', color: 'white', txt: 'Working on it', disabled: false },
  { backgroundColor: '#EC5353', color: 'white', txt: "Don't Have", disabled: false },
  { backgroundColor: '#848484', color: 'white', txt: 'N/A', disabled: false }
];

const DropdownMenu = ({ doc, changestatus }) => {
  const getSafeIndex = (status) => {
    const parsed = parseInt(status, 10);
    if (!isNaN(parsed) && parsed >= 0 && parsed < SELECT_DATA.length) {
      return parsed;
    }
    return 0;
  };

  const currentIndex = getSafeIndex(doc?.gap_status);
  const currentItem = SELECT_DATA[currentIndex] || SELECT_DATA[0];

  const [select, setSelect] = useState(currentItem.txt);
  const [color, setColor] = useState(currentItem.backgroundColor);

  useEffect(() => {
    const idx = getSafeIndex(doc?.gap_status);
    const item = SELECT_DATA[idx] || SELECT_DATA[0];
    setSelect(item.txt);
    setColor(item.backgroundColor);
  }, [doc?.gap_status]);

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="success"
        style={{ backgroundColor: color, color: 'white', borderColor: color }}
        id={`dropdown-gap-${doc?.id || 'default'}`}
        size="sm"
      >
        {select}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {SELECT_DATA.map((item, index) => (
          <Dropdown.Item
            key={index}
            style={{ backgroundColor: item.backgroundColor, color: item.color }}
            onClick={() => {
              if (doc?.id && typeof changestatus === 'function') {
                changestatus(doc.id, index);
              }
              setSelect(item.txt);
              setColor(item.backgroundColor);
            }}
            disabled={item.disabled}
          >
            {item.txt}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropdownMenu;
